import React, { FC, useCallback, useState } from 'react'
import { useRecoilState } from 'recoil';


// Mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Card from '@mui/material/Card';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';

// Store
import { CalculatorAmbarcatiuneState } from '../../../../store/calculator.store';

// styles
import { StyledContainer, StyledPaper, StyledFormContainer } from './calculator-ambarcatiune.styles';

const valToMetric = (value: number) => `${value} metri`;

export const CalculatorAmbarcatiune: FC = () => {
  const [ pageState, setPageState] = useRecoilState(CalculatorAmbarcatiuneState);
  const { unitate, lungime } = pageState;

  // State components
  const handleUnitateChange = (unitate: 'm' | 'ft') => { setPageState((prevState) => ({ ...prevState, unitate })) };
  const handleLungimeChange = (lungime: number) => { setPageState((prevState) => ({ ...prevState, lungime })) };
  const [dialogMeasurementOpenState, setDialogMeasurementOpenState] = useState(false);

  // Form compoents
  const handleSliderChange = (event: any, newValue: number | number[]) => handleLungimeChange(newValue as number);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('plm 1', event.target.value);
    // handleLungimeChange(event.target.value === '' ? 0 : Number(event.target.value))
  };

  // Dialogs
  const handleMeasurementModalOpenState = useCallback((openState: boolean) => setDialogMeasurementOpenState(openState), []);
  

  return (
    <StyledContainer component="main" maxWidth="lg" sx={{ mb: 4 }}>
      <Typography component="h2" variant="h2" align="center">
        Detalii ambarcatiune
      </Typography>

      <StyledPaper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
        <Grid container spacing={2}>
          <Grid component="div" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Box>
              <Typography variant="subtitle1" align="left" sx={{ lineHeight: 2 }}>
                Te rugăm să ne oferi câteva informații despre barca ta pentru a-ți putea oferi cel mai bun preț de cazare:
              </Typography>

              <StyledFormContainer>
                <Typography paragraph variant="body1" align="left">
                  Ce unitate de masură folosești pentru a măsura lungimea ambarcațiunii?
                </Typography>

                <ButtonGroup variant='outlined' aria-label="Unitate de masura" sx={{ flex: '1 0 0'}}>
                  <Button 
                    variant={unitate === 'm' ? 'contained' : void (0)} 
                    fullWidth
                    onClick={() => handleUnitateChange('m')}
                  >
                    Metri (m)
                  </Button>
                  <Button
                    variant={unitate === 'ft' ? 'contained' : void (0)}
                    fullWidth
                    onClick={() => handleUnitateChange('ft')}
                  >
                      Feet (ft)
                  </Button>
                </ButtonGroup>
              </StyledFormContainer>
              

              <StyledFormContainer noWrap>
                <Typography paragraph variant="body2" align="left" id="dimensiunile-barcii-paragraph">
                  Ce dimensiune are barca ta (in metrI)?  
                  <small onClick={() => handleMeasurementModalOpenState(true)}>Cum se măsoară corect lungimea? Click aici!</small>
                </Typography>

                <TextField
                  variant="outlined"
                  id="dimensiune-ambarcatiune"
                  value={lungime}
                  onChange={handleInputChange}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">{unitate}</InputAdornment>,
                  }}
                  inputProps={{
                    step: 0.5,
                    min: 1,
                    max: 12,
                    type: 'number',
                    'aria-labelledby': 'dimensiunile-barcii-paragraph',
                  }}
                />

                  <Dialog
                    open={dialogMeasurementOpenState}
                    onClose={() => handleMeasurementModalOpenState(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                  <DialogTitle id="alert-dialog-title">
                    Cum se măsoară corect lungimea ambarcațiunii?
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Let Google help apps determine location. This means sending anonymous
                      location data to Google, even when no apps are running.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => handleMeasurementModalOpenState(false)} autoFocus>
                      Am ințeles!
                    </Button>
                  </DialogActions>
                </Dialog>
              </StyledFormContainer>
  
              <Slider
                size="medium"
                aria-labelledby="dimensiunile-barcii-paragraph"
                value={lungime}
                getAriaValueText={valToMetric}
                valueLabelFormat={valToMetric}
                valueLabelDisplay="auto"
                step={0.1}
                marks={Array(13).fill(void (0)).map((_, index) => ({ value: index, label: `${index}` }))}
                min={1}
                max={12}
                sx={{ mt: 2 }}
                onChangeCommitted={handleSliderChange}
              />
            </Box>
          </Grid>
          <Grid component="div">
            <Card sx={{ maxHeight: '640px', borderRadius: 8 }}>
            
            </Card>
          </Grid>          
        </Grid>

      </StyledPaper>
    </StyledContainer>
  )
}
